import LoginView from 'modules/accountManagement/views/LoginView';

const LoginPage = () => <LoginView />;

LoginPage.propTypes = {};

LoginPage.defaultProps = {};

export default LoginPage;
